import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/hospitality/lodging")({
  component: LodgingPage,
});

// The /hospitality/lodging index renders the performance table directly.
// Child routes (folio-ar) use Outlet when lodging is the parent segment.
function LodgingPage() {
  return <Outlet />;
}
